import { useInviteRostersByProgramIds } from 'bundles/enterprise-admin-learners/hooks/useInviteRostersByProgramIds';

/**
 * Resolves the roster that a program/group has under a specific contract, so the
 * invite mutation can be scoped to it (see ContractSelectionStep). Skipped entirely
 * for single-contract orgs (no `contractId`) — the mutation works without a
 * `rosterId` today, matching pre-ENTADMIN-1962 behavior.
 */
export const useRosterIdForContract = (programId: string | undefined, contractId: string | undefined) => {
  const { rosterIdByProgramId, loading, error } = useInviteRostersByProgramIds(
    programId ? [programId] : [],
    contractId
  );

  const rosterId = programId ? rosterIdByProgramId?.get(programId) : undefined;
  // A query error leaves `rosterIdByProgramId` undefined, same as a not-yet-loaded state —
  // treat it as "no match" rather than falling through and submitting an unscoped invite
  // despite a contract having been selected.
  const hasNoMatch =
    !loading &&
    Boolean(programId) &&
    Boolean(contractId) &&
    (Boolean(error) || (rosterIdByProgramId !== undefined && !rosterId));

  return { rosterId, loading, hasNoMatch };
};

export default useRosterIdForContract;
